import { connect } from 'react-redux';
import MessageCountBadge from './message_count_badge';

const mapStateToProps = ({ user: { user } }) => ({
  count: user && user.badgeCounters?.unreadMessagesCountTotal
});

export default connect(mapStateToProps)(MessageCountBadge);
